import React from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  Text,
  VStack,
  AspectRatio,
  Center,
  useTheme,
} from '@chakra-ui/react';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';

import Link from '@repo/ui-components/tailwind/Link';
import SanityBackgroundImage from '../../../atoms/SanityBackgroundImage';
import MavenoidChatButton from '../../../atoms/MavenoidChatButton';

export default function DefaultSubMenu({ subMenu, setSubMenu }) {
  const theme = useTheme();

  return (
    <VStack mt="4" align="flex-start" pb="20">
      <Flex onClick={() => setSubMenu(null)} align="center" as="button" mb="6">
        <MdArrowBack size="24" />
        <Text textStyle="h3" ml="2">
          {subMenu.title}
        </Text>
      </Flex>
      {subMenu?.items.map(item => {
        if (item?.menuItemSupportChat) {
          return (
            <MavenoidChatButton key={item.title} mb="4">
              {item.title}
            </MavenoidChatButton>
          );
        }

        return (
          <Link className="font-light mb-4" key={item.title} link={item?.link}>
            {item.title}
          </Link>
        );
      })}

      {subMenu.moments?.map(moment => (
        <AspectRatio
          ratio={16 / 9}
          w="100%"
          key={moment.image?.asset?.url}
          mb="4"
          as={Link}
          link={moment?.link}
        >
          <SanityBackgroundImage
            w="100%"
            h="100%"
            borderRadius="lg"
            gradientGenerator={url =>
              `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.80) 49.56%), url(${url}), lightgray 50% / cover no-repeat;`
            }
            image={moment.image}
          >
            <Flex
              h="100%"
              w="100%"
              display="flex"
              alignItems="end"
              justify="space-between"
              p="4"
            >
              <Text
                textStyle="h3"
                as="h3"
                color="typography.lighter"
                maxW="80%"
                noOfLines={2}
              >
                {moment.headline}
              </Text>
              <Center
                backgroundColor="brand.sunny"
                borderRadius="full"
                w="40px"
                h="40px"
              >
                <MdArrowForward size="24" />
              </Center>
            </Flex>
          </SanityBackgroundImage>
        </AspectRatio>
      ))}
      <Flex
        pos="fixed"
        bottom="0"
        left="0"
        h="60px"
        py="2"
        px="6"
        backgroundColor="primary.base"
        w="full"
        align="center"
        justify="space-between"
        as={Link}
        link={subMenu?.link}
      >
        <Text color="typography.lighter">
          {subMenu?.ctaText || subMenu?.title}
        </Text>
        <MdArrowForward size="24" color={theme.colors.typography.lighter} />
      </Flex>
    </VStack>
  );
}

const momentShape = PropTypes.shape({
  image: PropTypes.shape({}),
  link: PropTypes.shape({
    href: PropTypes.string,
  }),
  headline: PropTypes.string,
});

DefaultSubMenu.propTypes = {
  setSubMenu: PropTypes.func.isRequired,
  subMenu: PropTypes.shape({
    moments: PropTypes.arrayOf(momentShape),
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.shape({
          href: PropTypes.string,
        }),
      })
    ).isRequired,
    link: PropTypes.shape({
      href: PropTypes.string,
    }),
    ctaText: PropTypes.string.isRequired,
  }).isRequired,
};
